import { escapeRegExp } from 'lodash';

// Area names may be multi-char with digits/underscores (e.g. "KCY2", "building_temp")
const PLACEHOLDER_PATTERNS = {
  '{area_name}': '[A-Za-z][A-Za-z0-9_]*?',
  '{row_number_2d}': '\\d{2,}',
  '{place_number_2d}': '\\d{2,}',
  '{level}': '\\d+',
};

const PLACEHOLDER_SPLIT_RE = /(\{area_name\}|\{row_number_2d\}|\{place_number_2d\}|\{level\})/;

const templateToRegExp = (template) => {
  const pattern = template
    .split(PLACEHOLDER_SPLIT_RE)
    .map((part) => PLACEHOLDER_PATTERNS[part] || escapeRegExp(part))
    .join('');
  return new RegExp(`^${pattern}$`);
};

/**
 * Detects if code is a storage place address built from a place address template
 * @param {string} code - The scanned code
 * @param {string[]} templates - Place address templates from terminal config
 * @returns {boolean}
 * @throws {Error} when no templates are provided (stale terminal config)
 * @example isPlaceAddress("A16P21L4", ["{area_name}{row_number_2d}P{place_number_2d}L{level}"]) // true
 */
export const isPlaceAddress = (code, templates) => {
  if (!templates?.length) {
    throw new Error('No place address templates in terminal config; regenerate and save the config');
  }
  return templates.some((template) => templateToRegExp(template).test(code));
};
